/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_8_TitleInputs */

const en_terms_section_8_title = /** @type {(inputs: Terms_Section_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Disclaimer of Warranties`)
};

const lv_terms_section_8_title = /** @type {(inputs: Terms_Section_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Garantiju atruna`)
};

/**
* | output |
* | --- |
* | "8. Disclaimer of Warranties" |
*
* @param {Terms_Section_8_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_8_title = /** @type {((inputs?: Terms_Section_8_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_8_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_8_title(inputs)
	return en_terms_section_8_title(inputs)
});